import { ThemeProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import OtherProfileSidebar from 'components/organisms/Sidebar/OtherProfileSidebar';
import { UserData, UserProfileData } from 'interfaces/UserData.interface';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import CollectedBody from './CollectedBody';
import CollectorsBody from './CollectorsBody';
import FeedBody from './FeedBody';
import GalleryBody from './GalleryBody';
import PaywallBody from './PaywallBody';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const Body = styled(Grid)(({ theme }) => ({
  position: 'relative',
}));

interface IProfileProps {
  data: UserProfileData;
  editing: boolean;
  setData: React.Dispatch<React.SetStateAction<UserProfileData>>;
}

const Profile: React.FC<IProfileProps> = ({ data, editing, setData }) => {
  const nevigate = useNavigate();
  // const { username } = useParams();
  const handlers = useSwipeable({
    // onSwiped: (eventData) => console.log("User Swiped!", eventData),
    onSwipedLeft: eventData => {
      if (window.innerHeight > window.innerWidth) {
        nevigate(-1);
      }
    },
    // preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const tab = new URLSearchParams(useLocation().search).get('tab');

  const tabComponent: { [key in string]: JSX.Element } = {
    Feed: <GalleryBody />,
    Collectors: <CollectorsBody data={data as UserData} />,

    Splits: <PaywallBody />,

    Backstage: <FeedBody user={data} />,

    Badges: <PaywallBody Feed={''} />,

    Collected: <CollectedBody />,
  };

  return (
    // props.page.gallery ? <GalleryBody /> : props.page.backstage ? <PaywallBody Feed={props.Feed} /> : props.page.feeds ? <FeedBody /> : <></>
    <>
      <React.Fragment>
        <ThemeProvider theme={colortheme}>
          <Body container {...handlers}>
            <Grid sx={{ flexWrap: 'nowrap' }} container>
              <Grid
                item
                xs={2.5}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '1rem 3rem',
                }}
              >
                <OtherProfileSidebar
                  editing={editing}
                  data={data}
                  setData={setData}
                />
              </Grid>

              <Grid
                item
                xs={12}
                lg={9.5}
                sx={{
                  padding: '1rem 3rem',
                  [colortheme.breakpoints.down('md')]: {
                    padding: '1rem',
                  },
                }}
              >
                {tab ? tabComponent[tab] : <GalleryBody />}
              </Grid>
            </Grid>
          </Body>
        </ThemeProvider>
      </React.Fragment>
    </>
  );
};

export default Profile;
